/**
 * The base of every texts class. A text is plain data, so it can be replaced later (loaded from the API): what varies is
 * a `{name}` placeholder in the text, never code around it.
 */
export abstract class ATexts {
    /** Fills the `{name}` placeholders; an unknown one stays as it is. */
    public format(text: string, values: Record<string, string | number>): string {
        return text.replace(/\{(\w+)\}/g, (placeholder: string, name: string): string => (name in values ? values[name].toString() : placeholder));
    }
}
